var _line, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrangeMango(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 21.3792,
    y1: 2.90983,
    x2: 18.0714,
    y2: 5.73357,
    stroke: "#76310A",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4074 17.1827C15.8303 22.9102 6.99686 23.7052 2.81574 21.7913C-0.363161 20.3362 -1.18876 18.2579 2.10905 15.3135C5.40685 12.369 2.23596 11.2593 6.46686 6.42114C10.6978 1.58302 16.7464 1.11331 20.0784 4.44533C23.4105 7.77736 22.9845 11.4553 19.4074 17.1827Z",
    fill: "url(#paint0_linear_553_24383)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2976 8.94046C20.0951 11.7079 23.4077 11.8496 23.4077 11.8496C23.4077 11.8496 24.8421 8.86025 23.2466 5.97166C21.6511 3.08307 18.6212 3.87056 18.6212 3.87056C18.6212 3.87056 16.5001 6.17305 18.2976 8.94046Z",
    fill: "#84D135"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_553_24383",
    x1: 20.2638,
    y1: 4.63069,
    x2: 2.60653,
    y2: 22.288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC03C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.653273,
    stopColor: "#FF8A00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeMango);
export default __webpack_public_path__ + "static/media/orangeMango.fc587db049e6b9b7b0eb917526be22a7.svg";
export { ForwardRef as ReactComponent };